import { Users, UserCheck, UserX, Percent } from "lucide-react";

const CARDS = [
  { k: "total", label: "Total Registered", Icon: Users, tone: "text-orange-400 border-orange-500/30 from-orange-500/20" },
  { k: "checked_in", label: "Checked In", Icon: UserCheck, tone: "text-teal-300 border-teal-500/30 from-teal-500/20" },
  { k: "not_arrived", label: "Not Arrived", Icon: UserX, tone: "text-rose-300 border-rose-500/30 from-rose-500/20" },
  { k: "attendance_rate", label: "Attendance Rate", Icon: Percent, tone: "text-amber-300 border-amber-500/30 from-amber-500/20", suffix: "%" },
];

export function AttendanceStats({ stats, prefix = "attendance" }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {CARDS.map(({ k, label, Icon, tone, suffix }) => (
        <div key={k} className={`rounded-2xl border bg-gradient-to-br to-transparent p-5 ${tone}`} data-testid={`${prefix}-${k.replace(/_/g, "-")}`}>
          <div className="flex items-start justify-between">
            <div className="text-[10px] tracking-[0.25em] uppercase text-slate-400 font-bold">{label}</div>
            <Icon size={20} />
          </div>
          <div className="mt-3 font-display text-4xl font-black text-white">{stats ? `${stats[k]}${suffix || ""}` : "—"}</div>
        </div>
      ))}
    </div>
  );
}
